import * as storeTypes from './user-group.store-types';
import axios from 'axios';
import {UserGroup} from './user-group.models';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isActiveRequest: false,
        selectedUserGroup: new UserGroup,
        isModalVisible: false,
    },
    mutations: {
        [storeTypes.SET_SELECTED_USER_GROUP]: (state, selectedUserGroup) => state.selectedUserGroup = selectedUserGroup,
        [storeTypes.SET_IS_MODAL_VISIBLE]: (state, isModalVisible) => state.isModalVisible = isModalVisible,
        [storeTypes.SET_IS_LOADING]: (state, isLoading) => state.isLoading = isLoading,
        [storeTypes.SET_IS_ACTIVE_REQUEST]: (state, isActiveRequest) => state.isActiveRequest = isActiveRequest,
    },
    actions: {
        async [storeTypes.ACTION_GET_USERS_GROUPS](store, {companyId = ''}) {
            store.commit(storeTypes.SET_IS_LOADING, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success, error, usersGroups}} = await axios.get(`/api/companies/${companyId}/users-groups`);

                        if (!success) {
                            return reject(error);
                        }

                        resolve(usersGroups.map(userGroup => UserGroup.fromArray(userGroup)));
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_LOADING, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_ADD_USER_GROUP](store, {companyId, userGroup}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.post(`/api/companies/${companyId}/users-groups`, {userGroup});

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_UPDATE_USER_GROUP](store, userGroup) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.put(`/api/users-groups/${userGroup._id}`, {userGroup});

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_REMOVE_USER_GROUP](store, userGroupId) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.delete(`/api/users-groups/${userGroupId}`);

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_SHOW_MODAL](store, userGroup = null) {
            if (userGroup) {
                store.commit(storeTypes.SET_SELECTED_USER_GROUP, UserGroup.fromArray(userGroup));
            }

            store.commit(storeTypes.SET_IS_MODAL_VISIBLE, true);
        },
        async [storeTypes.ACTION_HIDE_MODAL](store) {
            store.commit(storeTypes.SET_SELECTED_USER_GROUP, new UserGroup);
            store.commit(storeTypes.SET_IS_MODAL_VISIBLE, false);
        },
    },
    getters: {
        [storeTypes.GET_SELECTED_USER_GROUP]: state => state.selectedUserGroup,
        [storeTypes.GET_IS_MODAL_VISIBLE]: state => state.isModalVisible,
        [storeTypes.GET_IS_LOADING]: state => state.isLoading,
        [storeTypes.GET_IS_ACTIVE_REQUEST]: state => state.isActiveRequest,
    },
}